import {
  IAlarmCentralProps,
  IZoneAlarmCentralProps,
} from '../../../../../services/AlarmCentralService/types';
import { Grid2, Typography } from '@mui/material';
import { AlarmCentralEndpoint } from '../../../../../services/AlarmCentralService/enums';
import './AlarmCentralPhysical.css';
import { useSendBypassZones } from '../../../../../services/AlarmCentralService/Physical/hooks/useMutation';
import { useEffect, useState } from 'react';
import CardComponent from '../../../../../components/CardComponent/CardComponent';
import { IAlarmCentralJflStatusProps } from '../../../../../services/AlarmCentralService/Physical/Jfl/types';
import { ZoneStatusJfl } from '../../../../../services/AlarmCentralService/Physical/Jfl/enums';

interface AlarmCentralPhysicalJflZonesProps {
  alarmCentral: IAlarmCentralProps;
  status: IAlarmCentralJflStatusProps;
}

const AlarmCentralPhysicalJflZones = ({
  alarmCentral,
  status,
}: AlarmCentralPhysicalJflZonesProps) => {
  const {
    mutateAsync: mutateSendBypassZonesAsync,
    isLoading: isLoadingSendBypassZonesAsync,
  } = useSendBypassZones();
  const [isLoadingZone, setIsLoadingZone] = useState<boolean[]>([]);

  const renderDescriptionByStatus = (status: ZoneStatusJfl) => {
    switch (status) {
      case ZoneStatusJfl.DISABLED:
        return 'Desabilitada';
      case ZoneStatusJfl.INHIBITED:
        return 'Inibida';
      case ZoneStatusJfl.CLOSED:
        return 'Fechada';
      case ZoneStatusJfl.OPEN:
        return 'Aberta';
      case ZoneStatusJfl.NO_COMMUNICATION:
        return 'Sem comunicação';
      default:
        return '';
    }
  };

  const createZoneListToUpdate = (zoneIndexToUpdate: number) => {
    const zones: IZoneAlarmCentralProps[] = [];
    status.zonesStatus.forEach((zone, index) => {
      if (zoneIndexToUpdate == index) {
        zones.push({
          bypass: zone !== ZoneStatusJfl.INHIBITED,
          zoneCode: index + 1,
        });
      } else {
        zones.push({
          bypass: zone === ZoneStatusJfl.INHIBITED,
          zoneCode: index + 1,
        });
      }
    });
    return zones;
  };

  const inhibitedMessage = (zoneStatus: ZoneStatusJfl) => {
    return zoneStatus === ZoneStatusJfl.DISABLED
      ? ''
      : zoneStatus === ZoneStatusJfl.INHIBITED
        ? 'Clique para remover inibição'
        : 'Clique para inibir';
  };

  useEffect(() => {
    const isLoading: boolean[] = [];
    for (let i = 0; i < alarmCentral.zoneQuantity; i++) isLoading.push(false);

    setIsLoadingZone(isLoading);
  }, [status, alarmCentral]);

  return (
    <>
      {[...Array(alarmCentral.zoneQuantity)].map((z, index) => {
        const zoneStatus = status.zonesStatus[index];
        const zoneColor =
          zoneStatus === ZoneStatusJfl.CLOSED
            ? 'red'
            : zoneStatus === ZoneStatusJfl.OPEN
              ? 'green'
              : zoneStatus === ZoneStatusJfl.INHIBITED
                ? '#fff'
                : 'rgb(47, 57, 87)';

        return (
          <Grid2 key={index} size={{ md: 4, xs: 12 }}>
            <CardComponent
              disabled={zoneStatus === ZoneStatusJfl.DISABLED}
              isLoading={isLoadingZone[index]}
              onClick={() => {
                mutateSendBypassZonesAsync({
                  endpoint: AlarmCentralEndpoint.ALARM_CENTRAL_JFL_ENDPOINT,
                  id: alarmCentral.id,
                  data: createZoneListToUpdate(index),
                });
                const isl = [...isLoadingZone];
                isl[index] = true;
                setIsLoadingZone(isl);
              }}
              additionalMessage={renderDescriptionByStatus(zoneStatus)}
              representativeColor={zoneColor}
              tooltipMessage={inhibitedMessage(zoneStatus)}
            >
              <Typography sx={{ fontWeight: 'bold' }}>
                ZONA {index + 1}
              </Typography>
            </CardComponent>
          </Grid2>
        );
      })}
    </>
  );
};

export default AlarmCentralPhysicalJflZones;
